import { render, staticRenderFns } from "./rk-footer.vue?vue&type=template&id=72bca7a6&scoped=true&"
import script from "./rk-footer.vue?vue&type=script&lang=ts&"
export * from "./rk-footer.vue?vue&type=script&lang=ts&"
import style0 from "./rk-footer.vue?vue&type=style&index=0&id=72bca7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bca7a6",
  null
  
)

export default component.exports